import { gql } from '@apollo/client';

export const queryName = 'subscription';
export const membershipName = 'Membership';
export const membership = gql`
	fragment ${membershipName} on Member {
		membershipSubscription {
			type
			status
			upcomingInvoice {
				total
				nextPaymentAttempt
			}
			canceledAt
			cancelAt
      billingInterval
      isTrial
			nextSubscriptionRenewalDate
		}
	}
`;
